import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../../../app/app.service';
import { AdditionalComponentsVM, FamilyList, ModelSelectionFilter } from '../../GET_NEW_UI/favourite-dialog/favourite-dialog-modal';
import { FavouriteDialogService } from '../../GET_NEW_UI/favourite-dialog/favourite-dialog.service';
import { GETSetupEquipmentService } from '../../GET_NEW_UI/setup-equipment/setup-equipment.service';
import { FileReaderEvent } from '../../GET_NEW_UI/setup-implement/setup-implement.component';
import { GenericIdName } from '../../GET_NEW_UI/setup-implement/setup-implement.model';
import { ManageComponentsService } from '../../manage-components/manage-components.service';
import { ThermographyInspectionService } from '../thermography-inspection.service';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { heicTo } from 'heic-to';

@Component({
  selector: 'app-add-thermography-additonal-component',
  templateUrl: './add-thermography-additonal-component.component.html',
  styleUrls: ['./add-thermography-additonal-component.component.scss']
})
export class AddThermographyAdditonalComponentComponent implements OnInit {
  familyList: FamilyList[] = [];
  selectedFamily: number[] = []
  makeList: GenericIdName[] = [];
  modelList: GenericIdName[] = [];
  selectedMake: number[] = [];
  selectedModel: number[] = [];

  AdditionalComponentList: AdditionalComponentsVM[] = [];
  showTableView: boolean = false;
  isRowClick: boolean = false;

  isNew: boolean = true;
  selectedRow;
  selectedRowIndex_: number = 0;
  dataSource = new MatTableDataSource();
  public moduleid: string
  @ViewChild(MatSort) sort: MatSort;
  public modelNameID = []
  public modelId = []

  public Model_Id: string
  public Model_Names: string
  //model mat chip variables
  visible: boolean = true;
  selectable: boolean = true;
  removable: boolean = true;
  addOnBlur: boolean = true;

  componentName: string;
  selectedSystem: number;
  selectedSide: number;
  selectesIsBogie: number;
  selectedModelId: number;

  selectedAdditonalCompId: number = 0;
  displayedColumns = ['AdditionalComponent', 'System', 'Side', 'Model'];

  @ViewChild('userPhoto') userPhoto: ElementRef;

  constructor(private _favouriteDialogService: FavouriteDialogService, private _equipmentService: GETSetupEquipmentService,
    private _appService: AppService, private _thermographyService: ThermographyInspectionService,
    public _componentservice: ManageComponentsService, private _notify: NotificationsService,
    private _sanitizer: DomSanitizer,) { }

  ngOnInit() {
    this._appService.setPageTitle('Setup Additional Components');
    this.dataSource.sort = this.sort;
    this.loadMakes();
    this._componentservice.getModelList();
    this.loadAllFamilyList();
  }

  loadAllFamilyList() {
    this._favouriteDialogService.getllFamilyList().subscribe(res => {
      this.familyList = res;
    })
  }
  //  Makes
  loadMakes() {
    this._equipmentService.getMakeList().subscribe(r => {
      this.makeList = r;
    });
  }

  loadModelList() {
    this.modelList = null
    var params: ModelSelectionFilter = {
      Families: [],
      Makes: this.selectedMake
    }
    this._favouriteDialogService.GetModelsAvailable(params).subscribe(r => {
      if (r) {
        this.modelList = r;
      }
    });

  }

  componentSetupFormRest() {
    this.selectedFamily = [];
    this.selectedMake = [];
    this.selectedModel = [];
    this.showTableView = false;
    this.componentName = '';
    this.selectedSystem = null;
    this.selectedSide = null;
    this.selectesIsBogie = null;
    this.selectedModelId = null;
    this.isNew = true;
    this.imageUrl = "";
    this.imageUrl_ = "";
    this.moduleid=null;
    this.modelNameID = [];
    this.userPhoto.nativeElement.value = null;

  }


  GetComponentListForGrid() {
    this._thermographyService.GETAllAddditionalComponentsForModel(this.selectedModel).subscribe(res => {
      this.AdditionalComponentList = res;
      this.showTableView = true;
      this.dataSource.data = res;
    })
  }

  selectRow(row) {
    this.isRowClick = true;
    this.selectedRow = row;
    this.selectedRowIndex_ = 1
    this.selectedAdditonalCompId = row.AdditionalCompId;
    this.componentName = row.AddiCompName;
    this.selectedSystem = row.SystemTypeId;
    this.selectedSide = row.Side == true ? 2 : 1;
    this.selectesIsBogie = row.IsBoogie == true ? 1 : 2;
    this.selectedModelId = row.ModelId;
   
    this.isNew = false;

    this.LoadAdditonalComponentImage(row.AdditionalCompId);

  }


  //add Model to matchip
  addModel(id: number): void {
    if (id == 0) {

 

      var check = this.modelId.find(x => x == this.moduleid)
      if (!check) {
        //comming from model dropdown select
        this.modelId.push(this.moduleid);

        this._componentservice.availableModelList.map(x => {
          if (x.Id == parseInt(this.moduleid)) {
            this.modelNameID.push(x.Title)

          }
        })
      }

    } else if (id == 1) {
      //comming from Table row

      //get modelname array
      this.modelNameID.splice(0, this.modelNameID.length)
      this.modelId.splice(0, this.modelId.length)

      let modal_name = this.Model_Names.split(",")
      modal_name.forEach(element => {
        this.modelNameID.push(element)

      });

      let idwithname = this.Model_Id.split(",")
      idwithname.forEach(element => {
        this.modelId.push(element.split(':')[0])
      });
    }

  }


  removeModel(title: any): void {
    let index = this.modelNameID.indexOf(title);

    if (index >= 0) {
      this.modelNameID.splice(index, 1);
      this._componentservice.availableModelList.map(x => {
        if (x.Title == title) {
          this.modelId.splice(index, 1);
        }
      })
    }
  }


  ValidationCheck() {
    if (this.isNew == false) {
      if (this.componentName == "" || this.selectedSystem == null || this.selectedSide == null || this.selectesIsBogie == null || this.selectedModelId == null) {
        this._notify.error("Please fill out all required fields");
        return false;
      } else { return true; }
    } else {
      if (this.componentName == "" || this.selectedSystem == null || this.selectedSide == null || this.selectesIsBogie == null || this.modelId.length == 0) {
        this._notify.error("Please fill out all required fields");
        return false;
      } else { return true; }
    }

  }

  CreateNewComponenet() {
    if (this.ValidationCheck() == true) {

      const param = new AdditionalComponentsVM();
      param.AdditionalCompId = this.selectedAdditonalCompId;
      param.AddiCompName = this.componentName;
      param.ModelId = this.selectedModelId;
      param.Side = this.selectedSide == 2 ? true : false;
      param.SystemTypeId = this.selectedSystem;
      param.IsBoogie = this.selectesIsBogie == 1 ? true : false;
      param.ModelIdList = this.modelId;
      param.Image = this.imageUrl_;
      this._thermographyService.CreateNewAdditionalComponet(param).subscribe(res=>{
        if(res==true){
          this._notify.success("Create New Additional Component")
        }
      })

    }

  }
  // DeleteComponent(){

  // }

  UpdateComponent() {

    if (this.ValidationCheck() == true) {
      const param = new AdditionalComponentsVM();
      param.AdditionalCompId = this.selectedAdditonalCompId;
      param.AddiCompName = this.componentName;
      param.ModelId = this.selectedModelId;
      param.Side = this.selectedSide == 2 ? true : false;
      param.SystemTypeId = this.selectedSystem;
      param.IsBoogie = this.selectesIsBogie == 1 ? true : false;
      param.Image = this.imageUrl_;
      this._thermographyService.UpdateThermographyAdditionalComponentDetails(param).subscribe(result => {
        if (result == true) {
          this._notify.success("Updated Successfully")
        }
      })

    }

  }
  imageUrl: string="";
  imageUrl_: string="";

  // onSelectEquipmentPhoto(event) {
  //   if (event.target.files && event.target.files[0]) {
  //     var reader = new FileReader();

  //     reader.readAsDataURL(event.target.files[0]); // read file as data url

  //     reader.onload = (event: any) => { // called once readAsDataURL is completed
  //       this.imageUrl = event.target["result"];
  //       this.imageUrl_ = (event.target["result"]).split(',')[1];
  //     }
  //   }
  // }


// onSelectEquipmentPhoto(event: any) {
//   if (event.target.files && event.target.files[0]) {
//     let file = event.target.files[0];
//     const isHeic =
//       file.type === "image/heic" ||
//       file.name.toLowerCase().endsWith(".heic");
//     const processFile = (f: File) => {
//       const reader = new FileReader();
//       reader.readAsDataURL(f);
//       reader.onload = (e: any) => {
//         const result = e.target.result as string;
//         this.imageUrl = result;
//         this.imageUrl_ = result.split(',')[1];
//       };
//     };
//     if (isHeic) {
//       (heic2any as any).default({
//         blob: file,
//         toType: "image/jpeg",
//         quality: 0.8
//       })
//       .then((result: any) => {
//         const convertedBlob = Array.isArray(result) ? result[0] : result;
//         const convertedFile = new File([convertedBlob], "converted.jpg", {
//           type: "image/jpeg"
//         });
//         processFile(convertedFile);
//       })
//       .catch((err: any) => {
//         console.error("HEIC conversion failed", err);
//         this._notify.error("Failed to convert HEIC image. Please try a different image.");
//       });
//     } else {
//       processFile(file);
//     }
//     event.target.value = null;
//   }
// }

  async onSelectEquipmentPhoto(event: any): Promise<void> {

  if (!(event.target.files && event.target.files[0])) {
    return;
  }

  const file = event.target.files[0];

  const extension = file.name.split('.').pop()?.toLowerCase();
  const mimeType = (file.type || '').toLowerCase();

  const isHeic =
    extension === 'heic' ||
    extension === 'heif' ||
    mimeType.includes('heic') ||
    mimeType.includes('heif');

  const processFile = (f: File) => {

    const reader = new FileReader();

    reader.onload = (e: any) => {

      const result = e.target.result as string;

      this.imageUrl = result;
      this.imageUrl_ = result.split(',')[1];

    };

    reader.readAsDataURL(f);

  };

  try {

    if (isHeic) {

      console.log("HEIC detected");

      const convertedBlob = await heicTo({
        blob: file,
        type: "image/jpeg", // Use "toType" if required by your heic-to version
        quality: 0.8
      });

      const convertedFile = new File(
        [convertedBlob as Blob],
        "converted.jpg",
        {
          type: "image/jpeg"
        }
      );

      processFile(convertedFile);

    } else {

      processFile(file);

    }

  } catch (err: any) {

    console.error("HEIC conversion failed", err);

    this._notify.error(
      "Failed to convert HEIC image. Please try a different image."
    );

  }

  // Allow selecting the same file again
  event.target.value = null;

}

  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }
  LoadAdditonalComponentImage(CompId: number) {
    this._thermographyService.GETThermogarphyAdditonalCompImage(CompId).subscribe(res => {

      if (res != ""){
        this.imageUrl_ = res;
      }
        
      else {
        this.imageUrl_ = "";
        this.imageUrl = "";
        this.userPhoto.nativeElement.value = null;
      }

    })
  }

}
